
import Table, { TableColumn } from "../../../../../components/Table";
import { TableContainer } from "../../../styles";
import React, { useState } from "react";
import useGetMe from "../../../../../hooks/useCurrentUser";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import { formatDateView, formatMoney } from "../../../../adiqEdi/detalhesEdi/utils";
import { useHistory } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import { LiveTableProps, SingleChargeItem } from "../../types";


export const LiveTable: React.FC<LiveTableProps> = ({
  data,
  currentPage,
  pageSize,
  onPageChange,
  onEdit,
  onPageSizeChange,
}) => {
  const user = useGetMe();
  const isAdmin = user?.userType === 3;
  const [isLoading] = useState<boolean>(false);
  const formattedDate = (date: string) => formatDateView(date);
  const history = useHistory();

  return (
    <div>
      <LoadingOverlay
        show={isLoading}
        relative
      />

      <TableContainer>
        <Table
          dataSource={data.records}
          pagination={
            {
              defaultPageSize: pageSize,
              defaultCurrent: currentPage,
              current: currentPage,
              onShowSizeChange: (_, size) => {
                onPageSizeChange(size);
              },
              total: data.count,
              onChange: (pageNum) => onPageChange(pageNum),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} de ${total} cobranças`,
            }}
        >
          <TableColumn title="Código do Estabelecimento" dataIndex="merchantId" key="merchantId" />
          {(user.userType === 3 || user.userType === 6 || user.userType === 7) && (
            <TableColumn title="Nome Fantasia" dataIndex="nickName" key="nickName" />
          )}
          <TableColumn
            title="Data da Cobrança"
            key="finishDate"
            render={(record: any) => {
              const date = record.paymentDate || record.finishDate;
              return date ? formattedDate(date) : "-";
            }}
          />
          <TableColumn title="Valor" dataIndex="totalValue" key="totalValue" render={formatMoney} />
          <TableColumn title="Descrição" dataIndex="reason" key="reason" />
          <TableColumn
            title="Solicitante"
            key="solicitante"
            render={(_, record) => {
              const item = record as SingleChargeItem;
              return item.updatedBy || item.createdBy || "-";
            }}
          />
          {isAdmin && onEdit && (
            <TableColumn
              title="Editar"
              key="editar"
              align="center"
              render={(_, record) => (
                <EditOutlined
                  style={{ cursor: "pointer", fontSize: 18, color: "#faad14" }}
                  onClick={() => onEdit(record as SingleChargeItem)}
                />
              )}
            />
          )}
        </Table>
      </TableContainer>
    </div>
  )
}

export default LiveTable;
